import {
  IGetBeneficiaryBatchHistorySort,
  IGetBeneficiaryBatchHistorySortBy,
} from '@smiles/voebiz-core-beneficiaries/dist/Types/BeneficiaryBatchHistoryApi.types';
import { Dropdown, DropdownOptions } from 'components/Dropdown';
import { useHistoryBatch } from 'contexts/HistoryBatch';
import React, { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { historySort } from 'utils/dropdownLabels';

const HistoryBatchTableLabel = () => {
  const { filter, setFilter } = useHistoryBatch();

  const { t } = useTranslation(['summary', 'history']);

  const [currentOrderBy, setCurrentOrderByt] = useState(filter?.sort);

  const [isVisible, setIsVisible] = useState(false);

  const handleSort = useCallback(
    (type: string, by: string) => {
      const sort = type as IGetBeneficiaryBatchHistorySort;
      const sortBy = by as IGetBeneficiaryBatchHistorySortBy;
      setIsVisible(false);
      setCurrentOrderByt(sort);
      setFilter({ sort, sortBy });
    },
    [setFilter, setIsVisible],
  );

  const sort = historySort;

  const isSortAsc = useMemo(() => currentOrderBy === 'asc', [currentOrderBy]);

  const isSameSort = useMemo(() => filter?.sortBy === sort.type, [filter?.sortBy, sort.type]);

  const optionsInclude = useMemo<DropdownOptions[]>(
    () =>
      sort.labels.map((item) => ({
        onClick: () => handleSort(item.sort, sort.type),
        label: item.label,
        checked: item.sort === currentOrderBy,
      })),
    [currentOrderBy, handleSort, sort.labels, sort.type],
  );

  const icon = useMemo(() => {
    if (!filter?.sortBy) return 'arrow-down';

    return isSortAsc && isSameSort ? 'arrow-up' : 'arrow-down';
  }, [filter?.sortBy, isSameSort, isSortAsc]);

  return (
    <div className="beneficiaries-dropdown" data-testid="test-table-label">
      <button
        type="button"
        className="menu-trigger"
        onClick={() => setIsVisible(true)}
        data-testid="outside-click-button"
      >
        <div className="title-container">
          <span className={isVisible ? 'orange' : ''}>{t('history:date_inclusion_history')}</span>
          <span className={`table-beneficiaries ${icon}`} />
        </div>
      </button>
      <Dropdown
        close={() => setIsVisible(false)}
        open={isVisible}
        options={optionsInclude}
        id="dropdown-sort-history-batch"
      />
    </div>
  );
};

export default HistoryBatchTableLabel;
